import React from "react";
import { Badge } from "@/components/ui/badge";
import {
  MapPin, ChevronLeft, Home, Lock, LayoutGrid,
} from "lucide-react";

export function StopHeader({ selectedStop, currentIdx, totalStops, editingOrderId, lockedOrder, onBack }) {
  const hasDest = selectedStop.denominaz_1 && selectedStop.denominaz_1 !== selectedStop.denominaz;
  // denominaz = nome destinazione (es. "Laboratorio"); denominaz_1 = ragione sociale cliente (es. "DOMUS CARNE S.N.C.")
  const title = selectedStop.denominaz || selectedStop.ragione_sociale || selectedStop.denominaz_1;
  const clientLabel = hasDest ? selectedStop.denominaz_1 : null;

  return (
    <div className="flex items-start gap-3 mb-4">
      <button onClick={onBack}
        className="p-2 rounded-lg bg-white/5 hover:bg-white/10 text-zinc-400 hover:text-white transition-colors mt-1"
        data-testid="back-to-stops">
        <ChevronLeft className="w-5 h-5" />
      </button>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-1.5">
          {hasDest && <Home className="w-3.5 h-3.5 text-cyan-400 shrink-0" />}
          <h2 className="font-heading text-lg font-bold text-white truncate">{title}</h2>
        </div>
        {hasDest && (
          <p className="text-amber-400 text-[10px] font-bold truncate">cliente: {clientLabel}</p>
        )}
        {(selectedStop.indirizzo || selectedStop.localita) && (
          <p className="text-zinc-400 text-[11px] truncate flex items-center gap-1">
            <MapPin className="w-3 h-3 shrink-0" />
            {[selectedStop.indirizzo, selectedStop.localita].filter(Boolean).join(", ")}
          </p>
        )}
        <p className="text-zinc-600 text-[10px] truncate">{selectedStop.cod_cliente}</p>
      </div>
      <div className="flex flex-col items-end gap-1 shrink-0">
        <Badge className="bg-amber-500/20 text-amber-400">{currentIdx + 1}/{totalStops}</Badge>
        {selectedStop.tipo_listino === 2 && (
          <Badge
            className="bg-cyan-500/20 text-cyan-300 text-[10px] border border-cyan-500/30 font-mono font-bold"
            data-testid="stop-listino2-badge"
            title="Cliente su Listino 2 dedicato — prezzi base L2 applicati automaticamente"
          >
            LISTINO 2
          </Badge>
        )}
        {selectedStop.sconti_fissi && (
          <Badge
            className="bg-red-500/20 text-red-300 text-[10px] border border-red-500/40 font-mono font-bold"
            data-testid="stop-contrattualizzato-badge"
            title="Cliente contrattualizzato — prezzi e sconti non modificabili"
          >
            CONTRATTUALIZZATO
          </Badge>
        )}
        <a
          href="/catalog"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="open-catalog-new-tab"
          title="Apri il catalogo in una nuova scheda (per mostrare promo al cliente)"
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-md border border-cyan-500/40 bg-cyan-500/15 text-cyan-300 text-xs font-semibold hover:bg-cyan-500/25 transition-colors"
        >
          <LayoutGrid className="w-4 h-4" />
          Catalogo
        </a>
        {Number(selectedStop.sconto_canale) > 0 && (
          <Badge
            className="bg-violet-500/20 text-violet-300 text-[10px] border border-violet-500/30"
            data-testid="sconto-canale-badge"
            title="Sconto di canale applicato automaticamente al totale dell'ordine"
          >
            Sc. Canale {selectedStop.sconto_canale}%
          </Badge>
        )}
        {editingOrderId && (
          <Badge className="bg-blue-500/20 text-blue-400 text-[10px]" data-testid="editing-order-badge">
            Modifica
          </Badge>
        )}
        {lockedOrder && (
          <Badge className="bg-red-500/20 text-red-400 text-[10px]" data-testid="locked-order-badge">
            <Lock className="w-3 h-3 mr-1" />Bloccato
          </Badge>
        )}
      </div>
    </div>
  );
}
